import CommentParticipants from './CommentParticipants';

export default CommentParticipants;